// extracted by mini-css-extract-plugin
export default {"cont":"EmbeddedCode_cont__7ggl0","buttonCont":"EmbeddedCode_buttonCont__B5QK1"};